var render, staticRenderFns
import script from "./KModal.vue?vue&type=script&lang=js"
export * from "./KModal.vue?vue&type=script&lang=js"
import style0 from "./KModal.vue?vue&type=style&index=0&id=8c2e138c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2e138c",
  null
  
)

export default component.exports